let isProcessing = false;
let lastProcessedUrl = '';

function applyMetalFilter() {
  // Prevent multiple simultaneous executions
  if (isProcessing) return;
  
  const currentUrl = window.location.search;
  if (currentUrl === lastProcessedUrl) return;
  
  isProcessing = true;
  lastProcessedUrl = currentUrl;
  
  const entries = [...new URLSearchParams(window.location.search).entries()];
  // An active storefront filter must win over a static ?metal= param from the menu link.
  const metalEntry =
    entries.find(([key]) => key.toLowerCase().includes("filter.v.option.precious")) ||
    entries.find(([key]) => key.toLowerCase().includes("metal"));
  const metal = metalEntry ? metalEntry[1] : null;

  if (!metal) {
    isProcessing = false;
    return;
  }

  const normalizedMetal = decodeURIComponent(metal)
    .trim()
    .replace(/[-_+]+/g, ' ')
    .replace(/\s+/g, ' ')
    .toLowerCase();

  document.querySelectorAll(".product-item").forEach((item) => {
    const swatches = item.querySelectorAll(".swatch-element[data-value]");
    let targetVariantId = null;
    swatches.forEach((swatch) => {
      const value = swatch.getAttribute("data-value")?.toLowerCase() || "";

      if (value === normalizedMetal) {
        targetVariantId = swatch.getAttribute("data-variant-id");
      }
    });

    if (!targetVariantId) return;

    swatches.forEach((swatch) => swatch.classList.remove("active"));

    const targetSwatch = item.querySelector(
      `.swatch-element[data-variant-id="${targetVariantId}"]`
    );

    if (targetSwatch) {
      targetSwatch.classList.add("active");

      // Reuse the swatch click handler in custom-site.js - it already filters
      // the background image + hover slider down to the selected swatch's
      // color (data-swatch-color), so no need to duplicate that logic here.
      if (typeof targetSwatch.click === 'function') {
        targetSwatch.click();
      }

      const optionTitle = item.querySelector(
        ".variant-option-title span.body-medium"
      );
      if (optionTitle) {
        optionTitle.textContent = targetSwatch.getAttribute("data-value") || "";
      }
    }

    if (targetSwatch) {
      const priceEl = item.querySelector(".price-item--regular");
      const variantPrice = targetSwatch.getAttribute("data-variant-price");
      if (priceEl && variantPrice) {
        priceEl.textContent = variantPrice;
      }
    }
  });
  
  // Reset processing flag after completion
  setTimeout(() => {
    isProcessing = false;
  }, 100);
}

function initObserver() {
  const targetNode = document.querySelector('.collection__products') || document.querySelector('.product-grid');
  
  if (!targetNode) return;

  const observer = new MutationObserver((mutations) => {
    let shouldUpdate = false;
    
    for (const mutation of mutations) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        // Only trigger if new product items are added, not just any DOM changes
        const hasNewProducts = Array.from(mutation.addedNodes).some(node => 
          node.nodeType === 1 && (node.classList?.contains('product-item') || node.querySelector?.('.product-item'))
        );
        if (hasNewProducts) {
          shouldUpdate = true;
          break;
        }
      }
    }
    
    if (shouldUpdate) {
      setTimeout(applyMetalFilter, 200);
    }
  });

  observer.observe(targetNode, {
    childList: true,
    subtree: true
  });
}

document.addEventListener("DOMContentLoaded", () => {
  applyMetalFilter();
  initObserver();
  
  // Debounced event listeners to prevent excessive calls
  let facetTimeout;
  document.body.addEventListener('facet:updated', () => {
    clearTimeout(facetTimeout);
    facetTimeout = setTimeout(applyMetalFilter, 300);
  });
  
  document.body.addEventListener('facet:reinit', () => {
    clearTimeout(facetTimeout);
    facetTimeout = setTimeout(applyMetalFilter, 300);
  });
  
  const filterButtons = document.querySelectorAll('[data-filter-trigger]');
  filterButtons.forEach(button => {
    button.addEventListener('click', () => {
      setTimeout(applyMetalFilter, 500);
    });
  });
});

// Debounced popstate handler
let popstateTimeout;
window.addEventListener('popstate', () => {
  clearTimeout(popstateTimeout);
  popstateTimeout = setTimeout(applyMetalFilter, 200);
});
  